enum MeasurementType {
  LINEAR = 'LINEAR',
  ELLIPTICAL = 'ELLIPTICAL',
  VTI = 'VTI',
}

export default MeasurementType;
